"use client";

import { FilterablePaginatedSectionContext } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionContext";
import React, { useContext, ReactNode } from "react";

export const FilterablePaginatedSectionWrapper = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  const { scrollRef } = useContext(FilterablePaginatedSectionContext);

  return (
    <div
      className={className ?? "w-full p-4 md:p-6 lg:m-auto lg:px-12 lg:py-6"}
      ref={scrollRef}
    >
      {children}
    </div>
  );
};
